import { Component, OnInit, Input, Inject } from '@angular/core';
import { BaseComponent } from '../classes/BaseComponent';
import { Router } from '@angular/router';
import { StringHelper } from '../helpers/StringHelper';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-share',
  templateUrl: './share.component.html',
  styleUrls: ['./share.component.scss']
})
export class ShareComponent extends BaseComponent implements OnInit {

  @Input() url: string = "";
  @Input() itemTitle: string = "";
  link: string = "";

  constructor(
    private router : Router,
    private dom: DomSanitizer
  ) {
    super();
  }

  ngOnInit() {
    this.link = this.router.url;
  }

  selectInput(e) {
    this.shareClick('Clipboard');
    e.target.setSelectionRange(0, this.url.length);
    document.execCommand("copy");
    this.showClipboardToolTip();
  }

  copyLink() {
    this.shareClick('Clipboard');
    let element = document.getElementById("linkInput") as HTMLInputElement;
    element.select();
    document.execCommand("copy");
    this.showClipboardToolTip();
  }

  showClipboardToolTip() {
    const tooltip = document.getElementById("myCPTooltip");
    tooltip.innerHTML = this.getString('copied');
  }

  linkOut() {
    const tooltip = document.getElementById("myCPTooltip");
    tooltip.innerHTML = this.getString('copyToClipboard');
  }

  facebookShareURL(): string {
    return "https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fwww.cheapcharts.com" + this.link;
  }

  twitterShareURL(): string {
    return "https://twitter.com/intent/tweet?text=https%3A%2F%2Fwww.cheapcharts.com" + this.link;
  }

  emailShareURL(): string {
    return "mailto:?subject=" + StringHelper.format(this.getString("shareEmailSubject"), this.itemTitle) + "&body=https%3A%2F%2Fwww.cheapcharts.com" + this.link;
  }

  whatsAppURL(): SafeUrl {
    return this.dom.bypassSecurityTrustUrl("whatsapp://send?text=https://www.cheapcharts.com" + this.link);
  }

  shareClick(label: string) {
    if((<any>window).gtag) {
      (<any>window).gtag('event', 'ShareClick', {
        'event_category': 'DetailView',
        'event_label': label
      });
    }
    if ((<any>window)._paq) {
      (<any>window)._paq.push(['trackEvent', "DetailView", "ShareClick", label]);
    }
  }

  shareIconMouseEnter() {
    const tooltip = document.getElementById("myCPTooltip");
    tooltip.style.visibility = "visible";
    tooltip.style.opacity = "1";
  }

  shareIconMouseLeave() {
    const tooltip = document.getElementById("myCPTooltip");
    tooltip.style.visibility = null;
    tooltip.style.opacity = null;
    this.linkOut();
  }

  shareIconClick() {
    this.shareClick('Clipboard');
    const input:any = document.getElementById("linkInput");
    input.focus();
    input.setSelectionRange(0, this.url.length);
    document.execCommand("copy");
    this.showClipboardToolTip();
  }

}
